module.exports = __webpack_public_path__ + "img/jppdimg_mo6.283c9155.png";